// eslint-disable-next-line no-restricted-imports -- GetImageUrl is a helper, not a component, so it isn't exported from ui/components/*
import { GetImageUrl } from 'designsystem/src/helpers/getImageUrl';
import { heroMapper } from 'helpers/mappers';
import Head from 'next/head';
import { UI_HeroCard } from 'ui/components/2-molecules/Card/HeroCard/HeroCard';

export const HeroCardFeature: React.FC<Content.HeroCard> = (props) => {
	const { image } = props.content.properties;
	return (
		<>
			<UI_HeroCard {...heroMapper(props)} />
			<Head>{image?.url && <link rel="preload" as="image" href={GetImageUrl({ url: image.url, format: 'webp', width: 960 })} />}</Head>
		</>
	);
};
